import React from 'react';
import { Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
  heading: {
    marginBottom: theme.spacing(2),
  },
}));

const Unauthorized: React.FC = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <Typography variant="h4" className={classes.heading}>Unauthorized</Typography>
      <Typography>
        If you require access to the E-Permitting application, please contact the service desk at < a href="mailto:servicedesk@nutrien.com" > servicedesk@nutrien.com</a>
      </Typography>
    </Paper>
  );
};

export default Unauthorized;
